const LOCAL_API_BASE = ["http://localhost", "3000/api"].join(":")
const LOCAL_HTTPS_API_BASE = ["https://localhost", "3000/api"].join(":")

function normalizeTrailingSlash(value = "") {
  return String(value || "").replace(/\/+$/, "")
}

function isLocalFrontend() {
  if (typeof window === "undefined") return false

  const hostname = window.location.hostname

  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "0.0.0.0"
  )
}

export function getApiBaseUrl() {
  const envBase =
    process.env.REACT_APP_API_BASE ||
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    ""

  if (envBase) {
    return normalizeTrailingSlash(envBase)
  }

  if (isLocalFrontend()) {
    return LOCAL_API_BASE
  }

  return "/api"
}

export function buildApiUrl(path = "") {
  const base = getApiBaseUrl()
  const cleanPath = String(path || "")

  if (!cleanPath) return base

  if (/^https?:\/\//i.test(cleanPath)) {
    return normalizeApiUrl(cleanPath)
  }

  if (cleanPath.startsWith("/api/")) {
    if (isLocalFrontend()) {
      return `${LOCAL_API_BASE}${cleanPath.replace(/^\/api/, "")}`
    }

    return cleanPath
  }

  if (cleanPath === "/api") {
    return isLocalFrontend() ? LOCAL_API_BASE : "/api"
  }

  return `${base}${cleanPath.startsWith("/") ? cleanPath : `/${cleanPath}`}`
}

export function normalizeApiUrl(url = "") {
  const rawUrl = String(url || "")

  if (!rawUrl) return rawUrl

  const runtimeBase = getApiBaseUrl()

  if (rawUrl.startsWith(LOCAL_API_BASE)) {
    return `${runtimeBase}${rawUrl.slice(LOCAL_API_BASE.length)}`
  }

  if (rawUrl.startsWith(LOCAL_HTTPS_API_BASE)) {
    return `${runtimeBase}${rawUrl.slice(LOCAL_HTTPS_API_BASE.length)}`
  }

  if (rawUrl.startsWith("/api/") || rawUrl === "/api") {
    return buildApiUrl(rawUrl)
  }

  return rawUrl
}

export function buildAuthHeaders(includeJson = false) {
  const token = localStorage.getItem("odontoflow_token") || ""
  const clinicId = localStorage.getItem("odontoflow_clinic_id") || ""

  const headers = {}

  if (includeJson) {
    headers["Content-Type"] = "application/json"
  }

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  if (clinicId && clinicId !== "ALL") {
    headers["x-clinic-id"] = clinicId
  }

  return headers
}

function shouldIncludeJsonHeader(options = {}) {
  const existingContentType =
    options?.headers?.["Content-Type"] ||
    options?.headers?.["content-type"] ||
    ""

  if (String(existingContentType).toLowerCase().includes("application/json")) {
    return true
  }

  if (!options?.body) return false

  if (typeof FormData !== "undefined" && options.body instanceof FormData) {
    return false
  }

  return true
}

export async function apiFetch(url, options = {}) {
  const normalizedUrl = normalizeApiUrl(url)
  const includeJson = shouldIncludeJsonHeader(options)

  const finalOptions = {
    ...options,
    headers: {
      ...buildAuthHeaders(includeJson),
      ...(options.headers || {}),
    },
  }

  const res = await fetch(normalizedUrl, finalOptions)

  if (res.status === 401) {
    console.warn("Sesión expirada o inválida", {
      url: normalizedUrl,
      originalUrl: url,
    })
  }

  return res
}
